<!-- <form [formGroup]="form">
  <div fxLayout>
    <mat-form-field class="ea-thin-field" appearance="outline">
      <mat-label>{{label ? label : 'Filtra'}}</mat-label>
      <input matInput formControlName="text">
    </mat-form-field>
  </div>
</form>
 -->

<form [formGroup]="form" class="sm:w-[300px] w-full">

  <div class="flex flex-row justify-between light-background theme-color rounded-full p-1 px-4 " appearance="">

    <mat-icon class="material-icons-outlined mr-3">
      search
    </mat-icon>
    <input class="w-full bg-transparent " matInput formControlName="text"
      [placeholder]="(('searchBy' | translate) | async ) + ' ' + ((label | translate) | async)">
  </div>
</form>